<template>
  <div>
    <!-- 搜索框 -->

    <!-- jobgroup:'',//任务分组
        jobname:'',//任务名称
        jobstatus:1,//任务状态
        beanclass:'',//任务路径
        dealtstatus:''//处理状态 -->

    <a-card title="定时任务">
      <a-button slot="extra" type="primary" @click="handleNewTask">新建</a-button>
      <a-form layout="inline" @submit="handleSubmit" :form="form">

          <a-form-item label="任务分组">
              <a-input
                  v-model="searchP.jobgroup"
                  placeholder="任务分组"
              ></a-input>
          </a-form-item>

          <a-form-item label="任务名称">
              <a-input
                  v-model="searchP.jobname"
                  placeholder="任务名称"
              ></a-input>
          </a-form-item>


         <a-form-item label="执行任务路径">
              <a-input
                  v-model="searchP.beanclass"
                  placeholder="执行任务路径"
              ></a-input>
          </a-form-item>
          
           <a-form-item label="任务状态">
            <a-select v-model="searchP.jobstatus"  placeholder="" style="width:100px;">
                <a-select-option value="">
                全部
                </a-select-option>
                <a-select-option value="1">
                已启用
                </a-select-option>
                <a-select-option value="0">
                已关闭
                </a-select-option>
            </a-select>
          </a-form-item>

          

          <a-form-item label="处理状态">
            <a-select v-model="searchP.dealtstatus"  placeholder="" style="width:100px;">
                <a-select-option value="">
                全部
                </a-select-option>
                <a-select-option value="0">
                失败
                </a-select-option>
                <a-select-option value="1">
                成功
                </a-select-option>
                <a-select-option value="3">
                处理中
                </a-select-option>
                <a-select-option value="4">
                未处理
                </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item>
              <a-button
                  type="primary"
                  htmlType="submit"
                  :key="this.loading.key"

              >筛选</a-button>
          </a-form-item>
          <a-form-item>
            <a-button
                    type="default"
                    htmlType="submit"
                    :key="this.loading.key"
                    @click="handleSearchReset"
                >重置</a-button>
            </a-form-item>
      </a-form>
    </a-card>

    <!-- 系统列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" >
      <span slot="dealtstatus" slot-scope="text">{{ DealStattusMap[text] }}</span>
      <span slot="jobstatus" slot-scope="text">{{ DealJobStattusMap[text] }}</span>
      
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <span>
              <a-popconfirm title="确认修改？" @confirm="() => onChange(record)">
               <a>{{ record.jobstatus == '0' ? '开启' : '关闭' }}</a>
            </a-popconfirm>
          </span>
          <span>
            <router-link
                    :to="{
                    path:'detail',
                    query: {
                        id: record.id,
                        jobid: record.id
                    }
                }"
                >查看</router-link>
          </span>
           <span>
            <router-link
                    :to="{
                    path:'edit',
                    query: {
                        id: record.id
                    }
                }"
                >编辑</router-link>
          </span>
          <span>
            <a-popconfirm title="确认删除该条定时任务？?" @confirm="() => onTaskDelete(record)">
              <a>删除</a>
            </a-popconfirm>
          </span>
          <span>
            <a-popconfirm title="确认解锁?" @confirm="() => onUnlock(record)">
              <a>解锁</a>
            </a-popconfirm>
          </span>
          
        </div>
      </template>
    </a-table>

   <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange(pagination.current)" show-less-items show-quick-jumper />

 
 
  </div>
</template>
<script>
import { mapState } from "vuex";

// 0 - 失败  1-成功 3-处理中 4-未处理
const DealStattusMap = {
    0: '失败',
    1: '成功',
    3: '处理中',
    4: '未处理',
}
const DealJobStattusMap = {
    0: '关闭',
    1: '开启',
}
const columns = [
    {
        title: '序号',
        dataIndex: 'id',
        align: 'center',
        width: 50,
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: '任务名称',
        dataIndex: 'jobname',
        align: 'left',
        ellipsis: true,
    },
    {
        title: '任务分组',
        dataIndex: 'jobgroup',
        align: 'left',
        width: 80,
    },

    {
        title: '任务规则',
        dataIndex: 'cronexpression',
        align: 'left',
        width: 80,
    },
    {
        title: '备注',
        dataIndex: 'description',
        align: 'left',
    },
    {
        title: '执行任务类路径',
        dataIndex: 'beanclass',
        align: 'left',
        ellipsis: true,
    },
    {
        title: '类名',
        dataIndex: 'springid',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '方法名',
        dataIndex: 'methodname',
        align: 'center',
        width: 80,
    },
    {
        title: '最近一次耗时（ms）',
        dataIndex: 'consumetime',
        align: 'center',
        width: 140,
    },
    {
        title: '最近一次处理状态',
        dataIndex: 'dealtstatus',
        align: 'center',
        scopedSlots: { customRender: 'dealtstatus' },
        width: 120,
    },
    {
        title: '最近一次执行时间',
        dataIndex: 'dealtime',
        align: 'center',
    },
    {
        title: '创建时间',
        dataIndex: 'createtime',
        align: 'center',
    },
    {
        title: '任务状态',
        dataIndex: 'jobstatus',
        align: 'center',
        scopedSlots: { customRender: 'jobstatus' },
        width: 120,
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    },
];



const data = [];
let pagination={
    total:0,
    pageSize:0,
    current:1,
}
export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            type:'',
            editingKey: '',
            pagination,
            tLoading:true,
            DealStattusMap,
            DealJobStattusMap,
        };
    },
    methods: {
        getTaskList(cpage){
            let c_params = {
                ...this.searchP
            }
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            this.tLoading = true;
            this.$store.dispatch({
                type: "timetask/selectTask",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                this.data = result.list;
                this.pagination.total = result.totalRecords;
                this.pagination.pageSize = result.pageSize;
                this.pagination.current = result.page;
            })
        },
        handlePageChange(c_p){
            console.log("页码："+c_p)
            this.getTaskList(c_p)
        },
        handleSearchReset(){
            this.$store.dispatch({
                type: "timetask/getEmptySearch",
                showMsg: false
            })  
        },
        handleNewTask(){
            this.$router.push({
                path: "add",
                query: {id:''}
            });
        },
        handleSubmit(e){
            e.preventDefault();
            this.getTaskList()
        },
        //删除
        onTaskDelete(key) {
            this.tLoading = true;
            this.$store.dispatch({
                type: "timetask/deleteTask",
                params:{id:key.id}
            }).then((res) => {
                this.tLoading = false;
                if(res.data.success == '1'){
                    this.getTaskList()
                }
            }).c();
        },
        //解锁
        onUnlock(key) {
            this.$store.dispatch({
                type: "timetask/unlockTask",
                params:{id:key.id}
            }).then((res) => {
                if(res.status == '200'){
                    this.getTaskList();
                }
            });
        },
        //开关
        onChange(key) {
            let jobstatus= key.jobstatus=='0'?'1' :'2'
            console.log("key:"+jobstatus)
            this.$store.dispatch({
                type: "timetask/startTask",
                params:{id:key.id,type:jobstatus}
            }).then((res) => {
                if(res.status == '200'){
                    this.getTaskList();
                }
            });
        }
    },
    computed:{
        ...mapState('timetask', {
            searchP: state => state.searchP,
        })
    },
    components:{
    },
    mounted(){
        this.getTaskList();
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
